import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ClienteAnaliseMercadoRevisaoStatusValue, getClienteAnaliseMercadoRevisaoStatus, isClienteAnaliseMercadoRevisaoStatusSemRevisao } from '../../domain';

/** Propriedades do badge */
interface Props {
    status: number;
    revisao: number;
    versao: number;
}

/** Styles do badge */
interface Styles {
    fontSize: string
}

/** Badge do status da revisão das Análises de Mercado */
@Component({
    selector: 'sgt-cliente-analise-mercado-revisao-status-badge',
    templateUrl: './cliente-analise-mercado-revisao-status-badge.component.html',
    styleUrls: ['./cliente-analise-mercado-revisao-status-badge.component.less']
})
export class ClienteAnaliseMercadoRevisaoStatusBadgeComponent implements OnChanges {
    /** Propriedades para o badge */
    @Input() props: Props;
    /** Styles personalizados do badge */
    @Input() styles: Styles = {
        fontSize: '8px'
    }

    /** Status da revisão */
    status: ClienteAnaliseMercadoRevisaoStatusValue;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['props']) {
            this.setStatus();
        }
    }

    /** Seta o status da revisão */
    private setStatus() {
        this.status = getClienteAnaliseMercadoRevisaoStatus(this.props?.status ?? null);
    }
}
